<template>
  <div class="interests">
    <v-container class="px-0 pt-0" fluid grid-list-md>
      <v-layout class="ticket-cards">
        <slot name="cards" />
      </v-layout>
    </v-container>
    <v-card class="my-4 table-card">
      <v-card-title>
        <span class="pa-2 table-card-title">{{ tablesTitle }}</span>
        <v-tooltip bottom max-width="192px">
          <template v-slot:activator="{ on }">
            <span v-on="on">
              <mf-icon small color="cinza-0">info</mf-icon>
            </span>
          </template>
          <span>As informações dessa tela correspondem somente a clientes identificados</span>
        </v-tooltip>
        <v-spacer />
        <mf-tabs-button v-model="tableList" size="sm" class="mt-3" :buttons="toggleButtons" />
      </v-card-title>

      <div>
        <slot :table-list="tableList" name="table" />
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    tableList: 'cupons',
  }),
  computed: {
    tablesTitle() {
      if (this.tableList === 'cupons') return 'Quantidade vendida'
      return 'Faturamento por categoria'
    },
    toggleButtons() {
      return [
        {
          id: 0,
          label: 'Vendas',
          value: 'cupons',
          active: true,
        },
        {
          id: 1,
          label: 'Faturamento',
          value: 'faturamento',
          active: true,
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.interests {
  .ticket-cards {
    padding-top: 24px;
  }
  .table-card {
    min-height: 235px;
  }
}
</style>
